import type { FaireProductEntity } from "../../entity_types/product";

export const p_sa6ujnww6w: FaireProductEntity = {
  token: "p_sa6ujnww6w",
  type: "product",
  name: 'Madras Plaid Napkin-18"Sq-3742',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/06f15b6f22a074d402b688f3575a27f9455f2824f3c146af173cf6d4757f68e9.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.25,
  description:
    "Elevate your entertaining and your place settings with this stylish Madras Plaid Napkin. Crafted out of cotton, this smart, sophisticated-looking napkin features a rich complement of on-trend colours in a simple gingham plaid pattern to make any get-together a more stylish affair. Machine washable; matching Madras Plaid Placemat also available.",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:07.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
